import { _ as _objectWithoutProperties, a as _extends } from '../_rollupPluginBabelHelpers-b0164b33.js';
import React from 'react';
import PropTypes from 'prop-types';
import Bem from '../packages/honey-bem.js';
import { Injecss } from '../packages/injecss.js';
import { Icon } from './icon.js';

var styles = {
raw: ".hcr-btn-1-6-0{display:inline-block;position:relative;width:100%;min-width:142px;max-width:100%;height:44px;padding:0 12px;-webkit-transition:background .25s linear;transition:background .25s linear;border:0;border-radius:5px;font-family:Roboto Condensed,Arial,sans-serif;font-size:18px;font-weight:400;line-height:44px;text-align:center;text-decoration:none;text-overflow:ellipsis;white-space:nowrap;cursor:pointer;overflow:hidden;vertical-align:middle;-webkit-appearance:none;-moz-appearance:none;appearance:none}@media (min-width:600px){.hcr-btn-1-6-0{width:auto}}@media (min-width:1200px){.hcr-btn-1-6-0{height:36px;line-height:36px}}.hcr-btn-1-6-0+.hcr-btn-1-6-0{margin-top:12px}@media (min-width:600px){.hcr-btn-1-6-0+.hcr-btn-1-6-0{margin-top:0;margin-left:12px}}.hcr-btn--block-1-6-0{display:block;width:100%}.hcr-btn--square-1-6-0{width:44px;min-width:auto;padding:0;overflow:hidden}@media (min-width:1200px){.hcr-btn--square-1-6-0{width:36px}}.hcr-btn--square-1-6-0+.hcr-btn--square-1-6-0{margin-top:0;margin-left:12px}.hcr-btn--primary-1-6-0{border:0;background:#ffad00;color:#fff}.hcr-btn--primary-1-6-0.hcr-btn--loading-1-6-0,.hcr-btn--primary-1-6-0:active,.hcr-btn--primary-1-6-0:hover{background:#c68600;text-decoration:none}.hcr-btn--secondary-1-6-0{border:0;background:#73d700;color:#fff}.hcr-btn--secondary-1-6-0.hcr-btn--loading-1-6-0,.hcr-btn--secondary-1-6-0:active,.hcr-btn--secondary-1-6-0:hover{background:#5cac00;text-decoration:none}.hcr-btn--danger-1-6-0{border:0;background:#ff5700;color:#fff}.hcr-btn--danger-1-6-0.hcr-btn--loading-1-6-0,.hcr-btn--danger-1-6-0:active,.hcr-btn--danger-1-6-0:hover{background:#c64300;text-decoration:none}.hcr-btn--tertiary-1-6-0{border:1px solid #73d700;background:transparent;color:#73d700;line-height:42px}@media (min-width:1200px){.hcr-btn--tertiary-1-6-0{line-height:34px}}.hcr-btn--tertiary-1-6-0.hcr-btn--loading-1-6-0,.hcr-btn--tertiary-1-6-0:active,.hcr-btn--tertiary-1-6-0:hover{background-color:#5cac00;color:#fff;text-decoration:none}.hcr-btn-1-6-0:disabled,.hcr-btn--disabled-1-6-0{border:0;background:#c8c8c8;color:#fff;cursor:not-allowed}.hcr-btn-1-6-0:disabled:hover,.hcr-btn--disabled-1-6-0:hover{background:#c8c8c8;text-decoration:none}.hcr-btn--loading-1-6-0:before{display:inline-block;width:18px;height:18px;margin-top:-2px;margin-right:.5em;border-radius:50%;border:1px solid hsla(0,0%,100%,.6);border-left-color:#fff;content:\"\";vertical-align:middle;-webkit-animation:btn-spinner-rotate 1s linear infinite,btn-spinner-grow .25s;animation:btn-spinner-rotate 1s linear infinite,btn-spinner-grow .25s}@-webkit-keyframes btn-spinner-grow{0%{width:0;height:0;opacity:0}to{width:18px;height:18px;opacity:1}}@keyframes btn-spinner-grow{0%{width:0;height:0;opacity:0}to{width:18px;height:18px;opacity:1}}@-webkit-keyframes btn-spinner-rotate{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}@keyframes btn-spinner-rotate{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}.hcr-btn--has-icon-1-6-0.hcr-btn--loading-1-6-0:before{margin-left:.5em}.hcr-btn--has-icon-1-6-0.hcr-btn--loading-1-6-0 .hcr-btn__icon-1-6-0{display:none}.hcr-btn__icon-1-6-0{margin-top:-2px;vertical-align:middle}.hcr-btn__text-1-6-0{margin-right:.2em}.hcr-btn--danger-1-6-0 .hcr-btn__icon-1-6-0 svg,.hcr-btn--disabled-1-6-0 .hcr-btn__icon-1-6-0 svg,.hcr-btn--primary-1-6-0 .hcr-btn__icon-1-6-0 svg,.hcr-btn--secondary-1-6-0 .hcr-btn__icon-1-6-0 svg{fill:#fff}.hcr-btn--tertiary-1-6-0 svg{fill:#73d700}.hcr-btn--tertiary-1-6-0:disabled svg,.hcr-btn--tertiary-1-6-0:hover svg{fill:#fff}.hcr-btn__text-1-6-0{margin-left:.2em}",
map:{"hcr-btn":"hcr-btn-1-6-0","hcr-btn--block":"hcr-btn--block-1-6-0","hcr-btn--square":"hcr-btn--square-1-6-0","hcr-btn--primary":"hcr-btn--primary-1-6-0","hcr-btn--loading":"hcr-btn--loading-1-6-0","hcr-btn--secondary":"hcr-btn--secondary-1-6-0","hcr-btn--danger":"hcr-btn--danger-1-6-0","hcr-btn--tertiary":"hcr-btn--tertiary-1-6-0","hcr-btn--disabled":"hcr-btn--disabled-1-6-0","hcr-btn--has-icon":"hcr-btn--has-icon-1-6-0","hcr-btn__icon":"hcr-btn__icon-1-6-0","hcr-btn__text":"hcr-btn__text-1-6-0"}};

var bem = Bem('btn', styles);
var Button = function Button(_ref) {
  var appearance = _ref.appearance,
      Elem = _ref.Elem,
      RouterLink = _ref.RouterLink,
      extraClasses = _ref.extraClasses,
      InlineIcon = _ref.InlineIcon,
      loading = _ref.loading,
      display = _ref.display,
      type = _ref.type,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, ["appearance", "Elem", "RouterLink", "extraClasses", "InlineIcon", "loading", "display", "type", "children"]);

  var blockClass = bem.b([appearance, display, {
    loading: loading,
    'has-icon': InlineIcon
  }], extraClasses); // if type button nullify type prop

  var computedtype = Elem !== 'button' ? null : type;
  var WrapperElement = RouterLink !== null ? RouterLink : Elem;
  return React.createElement(WrapperElement, _extends({
    className: blockClass,
    type: computedtype
  }, rest), React.createElement(React.Fragment, null, InlineIcon ? React.createElement(Icon, {
    extraClasses: "".concat(bem.e('icon')),
    InlineIcon: InlineIcon
  }) : null, InlineIcon && children ? React.createElement("span", {
    className: bem.e('text')
  }, children) : React.createElement(React.Fragment, null, children)));
};
Button.displayName = 'Button';
Button.defaultProps = {
  appearance: 'primary',
  display: null,
  Elem: 'button',
  RouterLink: null,
  extraClasses: '',
  InlineIcon: null,
  loading: false,
  type: 'button'
};
Button.propTypes = {
  /** Appearance  */
  appearance: PropTypes.oneOf(['primary', 'secondary', 'tertiary', 'danger']),

  /** Content of the button. required if InlineIcon is not present */

  /* eslint-disable react/require-default-props */
  // we want label to be always checked against
  children: function children(_ref2) {
    var InlineIcon = _ref2.InlineIcon,
        _children = _ref2.children;
    // if no aria label nor label throw validation error
    return !InlineIcon && !_children ? new Error('Either children or InlineIcon are required') : null;
  },

  /** Force a given display mode */
  display: PropTypes.oneOf([null, 'block', 'square']),

  /** Define wrapping element */
  Elem: PropTypes.oneOf(['button', 'a', 'span']),

  /** Wraps your Button inside a RouterLink, e.g. if you use ReactRouter or a similar library.
   * If this prop is provided the Elem prop is beeing ignored */
  RouterLink: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),

  /** Injection in className */
  extraClasses: PropTypes.string,

  /** Optional icon needs to be an svg inline icon component */
  InlineIcon: PropTypes.func,

  /** set loading state */
  loading: PropTypes.bool,

  /** Type, only available for buttons */
  type: PropTypes.oneOf(['button', 'submit', 'reset'])
};
var Button$1 = Injecss(Button, styles);

export { Button$1 as Button };
